import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Col,  Form,  Input,  Row,  Radio,  Divider } from 'antd';
import EnhancedModal from '../../../../../components/enhanced-modal';
import { hideFileMappingWizardAddFieldModal, fileMappingWizardAddFieldValueType, onFunctionFormDataChange} from './actions';
import { GUTTER_MD, MARGIN_MD, SPAN_HALF, MODAL_WIDTH_LG } from '../../../../../styles/constants';
import FileMappingWizardAddFieldFunctionWizard from './function-wizard/index';
import FileMappingWizardPreviewRowList from './preview-row-list'
import FileMappingWizardFixedFormula from './fixed'
import FileMappingWizardCalculatedFormula from './calculated'
import _ from "lodash";
import FileComponentWizard from './function-wizard/file-wizard/FileComponentWizard';

const mapStateToProps = state => ({
  addFieldModalVisible: state.scenes.dataManager.fileMapping.components.wizard.components.addField.addFieldModalVisible,
  addFieldModalEditMode: state.scenes.dataManager.fileMapping.components.wizard.components.addField.addFieldModalEditMode,
  valueType: state.scenes.dataManager.fileMapping.components.wizard.components.addField.valueType,
  components: state.scenes.dataManager.fileMapping.components.wizard.shared.components,
  tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
  FunctionFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.FunctionFormData,
  functionType: state.scenes.dataManager.fileMapping.components.wizard.components.addField.functionType,
});

const mapDispatchToProps = dispatch => ({
  onAddFieldModalHide: () => dispatch(hideFileMappingWizardAddFieldModal()),
  setValueType: valueType => dispatch(fileMappingWizardAddFieldValueType(valueType)),
  onChange: fields => dispatch(onFunctionFormDataChange(fields)),
});

const mapPropsToFields = ({FunctionFormData}) => ({
  nameValue: Form.createFormField({value: FunctionFormData !== null ? FunctionFormData.nameValue : null}),
  functionValue: Form.createFormField({value: FunctionFormData !== null ? FunctionFormData.functionValue : null})
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const FileMappingWizardAddField = ({
                                      t,
                                      form,
                                      addFieldModalVisible,
                                      onAddFieldModalHide,
                                      valueType,
                                      setValueType,
                                      tempTableName,
                                      addFieldModalEditMode
                                    }) => {

  return (
    
    <Fragment>
      <EnhancedModal
        visible={addFieldModalVisible}
        width={MODAL_WIDTH_LG}
        title={addFieldModalEditMode ? t('data.fileMapping.addField.edit.label') : t('data.fileMapping.addField.title.label')}
        onCancel={onAddFieldModalHide}
      >
        <Row type="flex" justify="center">
            <Col style={{width: MODAL_WIDTH_LG}}>
              <Form className="advanced-form">
                <Row type="flex" justify="space-between" gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                    <Col span={SPAN_HALF}>
                        <Form.Item
                            className="form-item-required"
                            label={t('data.fileMapping.addField.name.label')}
                        >
                          {form.getFieldDecorator("nameValue")(
                            <Input 
                              title={form.getFieldValue("nameValue")}
                              style={{textTransform: "uppercase"}}
                            />
                          )}
                        </Form.Item>
                    </Col>
                    <Col span={SPAN_HALF}>
                        <Form.Item
                            className=""
                            label={t('data.fileMapping.addField.tableName.label')}
                        >
                          <Input
                            value={tempTableName}
                            className="ant-input-disabled"
                            style={{textTransform: "uppercase"}}
                            readOnly={true}
                           />
                        </Form.Item>
                    </Col>
                </Row>
              </Form>
            </Col>
        </Row>

        <Divider/>

        <Row type='flex' justify='start' style={{marginBottom: MARGIN_MD}}>
          <Radio.Group
            defaultValue={valueType}
            onChange={({target}) => setValueType(target.value)}
          >
            <Radio.Button value="1">
              {t('data.fileMapping.addField.fixed.label')}
            </Radio.Button>
            <Radio.Button value="2">
              {t('data.fileMapping.addField.calculated.label')}
            </Radio.Button>
          </Radio.Group>
        </Row>

        {(valueType === '1' ) && (
          <FileMappingWizardFixedFormula/>
        )}
        {(valueType === '2' ) && (
          <FileMappingWizardCalculatedFormula/>
        )}

        
      </EnhancedModal>
      <FileMappingWizardAddFieldFunctionWizard/>
      <FileMappingWizardPreviewRowList/>
      <FileComponentWizard />
    </Fragment>

);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
  )(FileMappingWizardAddField);